

import {
     Container,
     Stack,Button, 
    } from '@material-ui/core';
    // import Label from 'src/components/Label';
    import { Icon } from '@iconify/react';
    import plusFill from '@iconify/icons-eva/plus-fill';
    // routes
    import { PATH_DASHBOARD } from 'src/routes/paths.js';
    import { Link as RouterLink } from 'react-router-dom';
    // components
    import Page from 'src/components/Page.js';
    import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs.js';

import  UserRoleList from 'src/pages/dashboard/UserRoleList.js';



export default function ClientUserRole(){
  const userData = JSON.parse(localStorage.getItem('user'))
  const explodedPermissions =userData?.exploded_permissions
    return(
    <Page title="User Role | Joy Marketplace Support">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="flex-end">
          <Button
            disabled={userData?.user_type === 3 ? false : !explodedPermissions?.some(permission => ['Add Client User Role'].includes(permission))}
            variant="contained"
            sx={{ width: 'fit-content' , marginBottom: '20px'}}
            startIcon={<Icon icon={plusFill} />}
            component={RouterLink}
            to={PATH_DASHBOARD.client.userRoleAdd}
          >
          Add Client User Roles
          </Button>
        </Stack>
        <UserRoleList isClientUserRoles={true}/>
        
      </Container>
    </Page>
  );
}